import React from 'react'
import { Dialog, Typography, makeStyles } from '@material-ui/core'
import GlueIcon from '../glueos-components/glue-icon'
import GlueButton from '../glueos-components/glue-button'
import OrgIcon from '../glueos-components/org-icon'

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.custom.orgCreatedDialog.width,
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    gap: theme.spacing('xl'),
    textAlign: 'center'
  },

  title: {
    height: '64px',
    display: 'flex',
    alignItems: 'center'
  },

  // This following stuff is based on OrgAccordion but is not interactive
  orgNameBox: {
    width: theme.custom.orgAccordion.width,
    height: theme.custom.orgAccordion.height,
    background: theme.palette.orgAccordion.main,
    borderRadius: '4px'
  },

  orgNameContent: {
    width: '100%',
    height: '100%',
    display: 'flex',
    paddingLeft: theme.spacing('s')
  },

  orgName: {
    flex: '1',
    marginLeft: theme.spacing('s'),
    marginRight: theme.spacing('m'),
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    textAlign: 'left'
  },

  orgNameType: {
    flex: '1',
    color: theme.palette.orgAccordion.contrastText,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    opacity: '100%'
  }
}), { name: 'MuiGlueOrgCreatedDialog' })

const OrgCreatedDialog = (props) => {
  const classes = useStyles()

  return (
    <Dialog
      open={!!props.open}
      maxWidth={false}
    >
      <div className={classes.root}>
        <div className={classes.title}>
          <h2>You created a new organization</h2>
        </div>
        <div className={classes.orgNameBox}>
          <div className={classes.orgNameContent}>
            <GlueIcon>
              <OrgIcon
                name={props.orgName}
                id={props.orgId && props.orgId.slice(4)}
                variant='small'
                typeVariant='h3'
              />
            </GlueIcon>
            <div className={classes.orgName}>
              <Typography variant='overline' classes=>{props.orgName}</Typography>
            </div>
          </div>
        </div>
        <p>A verification email was sent to<br />{props.email}<br /><br />Please verify the email within two weeks!</p>
        <GlueButton width='152px' color='primary' onPointerDown={props.onCloseDialog}>Got it!</GlueButton>
      </div>
    </Dialog>
  )
}

export default OrgCreatedDialog
